import React from "react";
import ModalMobile from "../../../components/shared/Modal/ModalMobile";
import AllSet from "./components/AllSet";
import ApplyCredit from "./components/ApplyCredit";
import AutoRenew from "./components/AutoRenew";
import NotEnoughCredits from "./components/NotEnoughCredits";
import { useEffect } from "react";
import AutoRenewStop from "./components/AutoRenewStop";

export const steps = {
  APPLY_CREDIT: "APPLY_CREDIT",
  AUTO_RENEW: "AUTO_RENEW",
  AUTO_RENEW_STOP: "AUTO_RENEW_STOP",
  ALL_SET: "ALL_SET",
  NOT_ENOUGH_CREDITS: "NOT_ENOUGH_CREDITS",
};

const ModalAutoRenew = ({
  isOpen,
  initialModalStep,
  onClose,
  handleUpgradeStudent,
  handleAutoRenewal,
  user,
  student,
  onAddCredits,
  onRefetch,
}) => {
  const [currentStep, setCurrentStep] = React.useState(steps.APPLY_CREDIT);

  useEffect(() => {
    if (!isOpen) return;

    if (initialModalStep && initialModalStep === steps.AUTO_RENEW_STOP) {
      setCurrentStep(steps.AUTO_RENEW_STOP);
    } else if (
      initialModalStep &&
      initialModalStep === steps.AUTO_RENEW &&
      user.creditCount > 0
    ) {
      setCurrentStep(steps.AUTO_RENEW);
    } else if (user && (!("creditCount" in user) || user.creditCount <= 0)) {
      setCurrentStep(steps.NOT_ENOUGH_CREDITS);
    } else {
      setCurrentStep(steps.APPLY_CREDIT);
    }
  }, [isOpen, initialModalStep, user]);

  return (
    <ModalMobile
      isOpen={isOpen}
      onClose={onClose}
      className="p-6 sm:max-w-[480px] lg:max-w-[1128px] flex flex-col items-center text-center"
    >
      {currentStep === steps.APPLY_CREDIT && (
        <ApplyCredit
          onClose={onClose}
          user={user}
          student={student}
          handleCurrentStep={setCurrentStep}
          handleUpgradeStudent={handleUpgradeStudent}
        />
      )}

      {currentStep === steps.AUTO_RENEW && (
        <AutoRenew
          initialAutoRenew={initialModalStep === steps.AUTO_RENEW}
          onClose={onClose}
          user={user}
          student={student}
          handleCurrentStep={setCurrentStep}
          handleAutoRenewal={handleAutoRenewal}
          onRefetch={onRefetch}
        />
      )}

      {currentStep === steps.AUTO_RENEW_STOP && (
        <AutoRenewStop
          onClose={onClose}
          user={user}
          student={student}
          handleCurrentStep={setCurrentStep}
          handleAutoRenewal={handleAutoRenewal}
          onRefetch={onRefetch}
        />
      )}

      {currentStep === steps.ALL_SET && <AllSet onClose={onClose} />}

      {currentStep === steps.NOT_ENOUGH_CREDITS && (
        <NotEnoughCredits onClose={onClose} onAddCredits={onAddCredits} />
      )}
    </ModalMobile>
  );
};

export default ModalAutoRenew;
